export default __webpack_public_path__ + "static/media/inside2.24bb9e5b.jpg";